<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndat"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndat'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntim"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntim'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S121G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_35'><span class='brt high default' id='text3'>MAIN MENU</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_24 col_01'><span class='brt high default' id='text4'>ENTER SELECTION CRITERIA</span>  </div>
  <div class='lgr_00 col_26'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_25 col_02'><dynamic-field [id]='"blnk1"' [size]=25 [line]=5 [column]=2 [(ngModel)]='blnk1'></dynamic-field></div>
  <div class='lgr_00 col_28'>  </div>
  <div class='lgr_20 col_50'><dynamic-field [id]='"blnk2"' [size]=20 [line]=5 [column]=50 [(ngModel)]='blnk2'></dynamic-field></div>
  <div class='lgr_00 col_71'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_20 col_54'><dynamic-field [id]='"blnk3"' [size]=20 [line]=6 [column]=54 [(ngModel)]='blnk3'></dynamic-field></div>
  <div class='lgr_00 col_75'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_08'><span class='brt high default' id='text9'>CONTROL#:</span>  </div>
  <div class='lgr_15 col_18'><dynamic-field [id]='"cntrlno"' [size]=15 [line]=7 [column]=18 [(ngModel)]='cntrlno'></dynamic-field></div>
  <div class='lgr_00 col_34'>  </div>
  <div class='lgr_02 col_50'><dynamic-field [id]='"frmmm"' [size]=2 [line]=7 [column]=50 [(ngModel)]='frmmm'></dynamic-field></div>
  <div class='lgr_01 col_53'><dynamic-field [id]='"blnk4"' [size]=1 [line]=7 [column]=53 [(ngModel)]='blnk4'></dynamic-field></div>
  <div class='lgr_02 col_55'><dynamic-field [id]='"frmdd"' [size]=2 [line]=7 [column]=55 [(ngModel)]='frmdd'></dynamic-field></div>
  <div class='lgr_01 col_58'><dynamic-field [id]='"blnk5"' [size]=1 [line]=7 [column]=58 [(ngModel)]='blnk5'></dynamic-field></div>
  <div class='lgr_02 col_60'><dynamic-field [id]='"frmyy"' [size]=2 [line]=7 [column]=60 [(ngModel)]='frmyy'></dynamic-field></div>
  <div class='lgr_00 col_63'>  </div>
  <div class='lgr_02 col_67'><dynamic-field [id]='"tomm"' [size]=2 [line]=7 [column]=67 [(ngModel)]='tomm'></dynamic-field></div>
  <div class='lgr_01 col_70'><dynamic-field [id]='"blnk6"' [size]=1 [line]=7 [column]=70 [(ngModel)]='blnk6'></dynamic-field></div>
  <div class='lgr_02 col_72'><dynamic-field [id]='"todd"' [size]=2 [line]=7 [column]=72 [(ngModel)]='todd'></dynamic-field></div>
  <div class='lgr_01 col_75'><dynamic-field [id]='"blnk7"' [size]=1 [line]=7 [column]=75 [(ngModel)]='blnk7'></dynamic-field></div>
  <div class='lgr_02 col_77'><dynamic-field [id]='"toyy"' [size]=2 [line]=7 [column]=77 [(ngModel)]='toyy'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_05 col_12'><dynamic-field [id]='"blnk8"' [size]=5 [line]=10 [column]=12 [(ngModel)]='blnk8'></dynamic-field></div>
  <div class='lgr_06 col_18'><dynamic-field [id]='"pnrno"' [size]=6 [line]=10 [column]=18 [(ngModel)]='pnrno'></dynamic-field></div>
  <div class='lgr_00 col_25'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_15 col_02'><dynamic-field [id]='"blnk9"' [size]=15 [line]=11 [column]=2 [(ngModel)]='blnk9'></dynamic-field></div>
  <div class='lgr_19 col_18'><dynamic-field [id]='"psgrnm"' [size]=19 [line]=11 [column]=18 [(ngModel)]='psgrnm'></dynamic-field></div>
  <div class='lgr_00 col_38'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_16 col_01'><dynamic-field [id]='"blnk10"' [size]=16 [line]=13 [column]=1 [(ngModel)]='blnk10'></dynamic-field></div>
  <div class='lgr_20 col_18'><dynamic-field [id]='"fopdpd"' [size]=20 [line]=13 [column]=18 [(ngModel)]='fopdpd'></dynamic-field></div>
  <div class='lgr_00 col_39'>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_03'><dynamic-field [id]='"blnk11"' [size]=40 [line]=14 [column]=3 [(ngModel)]='blnk11'></dynamic-field></div>
  <div class='lgr_00 col_44'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_05 col_01'><dynamic-field [id]='"blnk12"' [size]=5 [line]=16 [column]=1 [(ngModel)]='blnk12'></dynamic-field></div>
  <div class='lgr_64 col_07'><dynamic-field [id]='"fopdpd2"' [size]=64 [line]=16 [column]=7 [(ngModel)]='fopdpd2'></dynamic-field></div>
  <div class='lgr_00 col_72'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_29 col_01'><span class='brt high default' id='text18'>PRESS ENTER FOR ON-LINE QUERY</span>  </div>
  <div class='lgr_24 col_31'><span class='brt high default' id='text19'> OR PF12 FOR BATCH QUERY</span>  </div>
  <div class='lgr_00 col_57'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'>
    <dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln' (ngModelChange)="onChange()"  [hidden]="this.s1dbgMessage.value.trim() !== ''"></dynamic-field>
  </div>
</div>


<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text21'>PF:</span>  </div>
  <div class='lgr_06 col_13'><span class='brt high default' id='text22'>4-EXIT</span>  </div>
  <div class='lgr_08 col_71'><span class='brt high default' id='text23'>12-PRINT</span>  </div>
</div>
<div class='lgr_col' *ngIf="this.s1dbgMessage.value.trim() == ''">
  <div class='lgr_09 col_01'><span class='brt high default' id='text24'>SHIFT PF:</span>  </div>
  <div class='lgr_17 col_25'><dynamic-field [id]='"prevc1"' [size]=17 [line]=24 [column]=25 [(ngModel)]='prevc1'></dynamic-field></div>
</div>
<div class='lgr_col' *ngIf="this.s1dbgMessage.value.trim() != ''">
  <div class='lgr_79 col_01'><dynamic-field [id]='"s1dbgMessage"' [size]=79 [line]=1 [column]=1 [(ngModel)]='s1dbgMessage'></dynamic-field></div>
</div>
</div>
